// extracted by mini-css-extract-plugin
export default {"parent":"Administration_parent__jT8D-","content":"Administration_content__BXBLF"};